const headers = [
  { title: 'Kode', key: 'code', sortable: true },
  { title: 'Nama', key: 'name', sortable: true },
  { title: 'Created At', key: 'created_at', sortable: true },
  { title: 'Updated At', key: 'updated_at', sortable: true },
  { title: 'Actions', key: 'actions', sortable: false, align: 'center' },
];

const filters = [
  { title: 'Kode', key: 'code', type: 'text' },
  { title: 'Nama', key: 'name', type: 'text' },
];

export { filters, headers };
